//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

let SideBarRoutes = [
  {
    name: 'My Dashboard',
    to: '/dashboard/mydashboard',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Redeem My Points',
    to: '/dashboard/redeem',
    isAdmin: false,
    isRedirect: false,
    childRoutes: ['/dashboard/redeem-confirmation'],
  },
  {
    name: 'View My Activity',
    to: '/dashboard/dashboard',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'View My Statements',
    to: '/dashboard/statements',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'My Benefit Statement',
    to: '/dashboard/benefit-statement',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Manage My Account',
    to: '/dashboard/manage',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Authorized Members',
    to: '/dashboard/authorized-members',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Manage My Account',
    to: '/dashboard/locations',
    isAdmin: false,
    isRedirect: false,
    childRoutes: [
      '/dashboard/add-billto',
      '/dashboard/view-shipto',
      '/dashboard/add-shipto',
      '/dashboard/dormant-view'
    ],
  },
  {
    name: 'Promotions',   // US
    to: 'https://www.henryschein.com/us-en/Dental/thrive-rewards/thrive-rewards-promotions.aspx',
    isAdmin: false,
    isRedirect: true,
    childRoutes: [],
    linkName:'Sidebar_Promotion'
  },
  {
    name: 'Promotions',   // CANADA
    to: 'https://www.henryschein.ca/en-ca/about/thrive-rewards-program/promotions',
    to_fr: 'https://www.henryschein.ca/fr-ca/about/thrive-rewards-program/promotions',
    isAdmin: false,
    isRedirect: true,
    childRoutes: [],
    linkName:'Sidebar_Promotion'
  },  
  {
    name: 'View My Benefits',  // US
    to: 'https://www.henryschein.com/us-en/Dental/thrive-rewards/thrive-rewards-program-benefits.aspx',
    isAdmin: false,
    isRedirect: true,
    childRoutes: [],
    linkName:'Sidebar_View_My_Benefits'
  },
  
  {
    name: 'View My Benefits',  // CANADA
    to: 'https://www.henryschein.ca/en-ca/about/thrive-rewards-program',
    to_fr: 'https://www.henryschein.ca/fr-ca/about/thrive-rewards-program',
    isAdmin: false,
    isRedirect: true,
    childRoutes: [],
    linkName:'Sidebar_View_My_Benefits'
  },   
  {
    name: 'Setup Privilege Code',
    to: '/dashboard/privilege',
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/view-loyalty-account-shipto'],
  },
  {
    name: 'Reports',
    to: '/dashboard/report',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Settings',
    to: '/dashboard/settings',
    isAdmin: true,
    isITAdmin:true,
    isRedirect: false,
    childRoutes: ['/dashboard/edit-settings'],
  },
  {
    name: 'MPC Configurations',
    to: '/dashboard/mpc',
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/mpcdetail'],
  },
  {
    name: 'Product Exclusion / Inclusion',
    to: '/dashboard/product-exclusione-inclusion',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Products",
    to: "/dashboard/product",
    isAdmin: true,
    isRedirect: false,
    childRoutes: ["/dashboard/productdetail"],
  },
  {
    name: "Points Adjustment",
    to: "/dashboard/overwrite",
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/view-overwrite'],
  },
  {
    name: 'Import Data',
    to: '/dashboard/ach-loyalty-points',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Enrollment',
    // name: "Enrollment / Transfer",
    to: '/dashboard/create-users',
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/user-confirmation'],
  },
  // {
  //   name: "Points Adjustment",
  //   to: "/dashboard/transactions",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: ["/dashboard/view-transaction"],
  // },
  // {
  //   name: "Max Merch",
  //   to: "/dashboard/max-merch",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },
  {
    name: 'Approval',
    to: '/dashboard/approval',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Email Logs',
    to: '/dashboard/email-logs',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Tier Assignment',
    to: '/dashboard/tier-assignment',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Promotion Management',
    to: '/dashboard/promotion',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/create-promotion',
      '/dashboard/view-promotion',
      '/dashboard/criteria',
      '/dashboard/create-criteria',
      '/dashboard/view-criteria',
      '/dashboard/range',
      '/dashboard/create-range',
      '/dashboard/view-range',
      '/dashboard/criteria-rule'
    ],
  },
  {
    name: 'Audit Config',
    to: '/dashboard/audit-config',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/create-audit-config',
      '/dashboard/view-audit-config',
    ],
  },
  {
    name: 'User Details',
    to: '/dashboard/user-details',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Shipto Details',
    to: '/dashboard/shipto-details',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Redemption Details',
    to: '/dashboard/redemption-details',
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/view-redemption-detail'],
  },
  {
    name: 'Affiliated Shipto Details',
    to: '/dashboard/loyalty-affiliation',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Member Account Details',
    to: '/dashboard/member-details',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Member Tier Audit',
    to: '/dashboard/loyalty-tier-audit',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Consent Approval",
    to: "/dashboard/ConsentApproval",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Create New Admin",
    to: "/dashboard/create-new-admin",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Roles',
    to: '/dashboard/role',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/create-role',
      '/dashboard/view-role'
    ],
  },
  {
    name: 'Screens',
    to: '/dashboard/screen',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/create-screen',
      '/dashboard/view-screen'
    ],
  },
  {
    name: 'Response',
    to: '/dashboard/response',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/create-response',
      '/dashboard/view-response'
    ],
  },
  {
    name: 'Benefit Code',
    to: '/dashboard/benefit-code',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/create-benefit-code',
      '/dashboard/view-benefit-code'
    ],
  },
  {
    name: 'KPI Reports',
    to: '/dashboard/kpi-reports',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Drive To Thrive",
    to: "/dashboard/drive-to-thrive",
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Job Audit Log',
    to: '/dashboard/view-job-audit-log',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/view-job-audit-log',
    ],
  },
  {
    name: 'Contract Code',
    to: '/dashboard/contract-code',
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/contract-code-detail'],
  },
  {
    name: 'Tier Range',
    to: '/dashboard/tierrange',
    isAdmin: true,
    // isITAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/tierrangedetail'],
  },
  {
    name: 'Cron List',
    to: '/dashboard/cronlist',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Unconsented Member Accounts",
    to: "/dashboard/unconsented-member-accounts",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/deactivated-member-accounts'
    ],
  },
  {
    name: 'Email Template',
    to: '/dashboard/emailtemplate',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [
      '/dashboard/view-emailtemplate'
    ],
  },
  {
    name: 'Manage Signature Accounts',
    to: '/dashboard/manage-signature-accounts',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Manage Service Plus Accounts',
    to: '/dashboard/manage-service-plus-accounts',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Negative Points",
    to: "/dashboard/negativepoints",
    isAdmin: true,
    isRedirect: false,
    childRoutes: ["/dashboard/negativedetail"],
  },
  // {
  //   name: 'Audit Signature',
  //   to: '/dashboard/audit-signature',
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },
  // {
  //   name: 'Audit Service Plus',
  //   to: '/dashboard/audit-service-plus',
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },
  {
    name: 'Audit Login',
    to: '/dashboard/audit-login',
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Billto Configuration",
    to: "/dashboard/billto-configuration",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'HSB Points Correction',
    to: '/dashboard/hsb-points-correction',
    isAdmin: true,
    isRedirect: false,
    childRoutes: ['/dashboard/hsb-points-correction-detail'],
  },
  {
    name: "Restricted Billto",
    to: "/dashboard/restricted-shipto",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: 'Thrive Rewards Backdate',
    to: '/dashboard/thrive-backdate',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Points Management",
    to: "/dashboard/points-management",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Banner Setup",
    to: "/dashboard/banner-setup",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Points Transfer",
    to: "/dashboard/pointstransfer",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Redirection Links",
    to: "/dashboard/redirectionlinks",
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },

  // {
  //   name: "Thrive Signature Request",
  //   to: "/dashboard/thrive-signature-request",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },

  // {
  //   name: "Thrive Service plus Request",
  //   to: "/dashboard/thrive-service-plus-request",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },
  {
    name: "Email Template Service",
    to: "/dashboard/email-template-service",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  // {
  //   name: "Signature Enrollments",
  //   to: "/dashboard/signature-enrollments",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: []
  // },
  // {
  //   name: "Signature Unenrollments",
  //   to: "/dashboard/signature-unenrollments",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: []
  // },
  {
    name: "GepRedirection Links",
    to: "/dashboard/gepredirectionlinks",
    isAdmin: true,
    isITAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },

  {
    name: "Dashboard Analytics",
    to: "/dashboard/google-analyst",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  {
    name: "Stacking Promotion",
    to: "/dashboard/stacking-promotion",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  // {
  //   name: "Thrive StartUp Enrollments",
  //   to: "/dashboard/thrive-startup-enrollments",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: []
  // },

  {
    name: 'Manage Startup Accounts',
    to: '/dashboard/manage-startup-accounts',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },

  {
    name: 'Promo Code Creation',
    to: '/dashboard/promo-code-creation',
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },
  // {
  //   name: 'Manage Unlock Accounts',
  //   to: '/dashboard/manage-unlock-accounts',
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },
  // {
  //   name: 'Unlock MileStone Tracking',
  //   to: '/dashboard/unlock-milestone-tracking',
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },
  // {
  //   name: "Startup Unenrollments",
  //   to: "/dashboard/startup-unenrollments",
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: []
  // },
  // {
  //   name: 'Audit Startup',
  //   to: '/dashboard/audit-startup',
  //   isAdmin: true,
  //   isRedirect: false,
  //   childRoutes: [],
  // },

  {
    name: "Thrive Campaign",
    to: "/dashboard/thrive-campaign",
    isAdmin: true,
    isRedirect: false,
    childRoutes: [],
  },

];

export default SideBarRoutes;
